// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7e5d029e","239":"212f1066","455":"a958114c"}[chunkId] + ".chunk.js";
};